import { createAsyncThunk } from '@reduxjs/toolkit';
import { isNotDefined } from '@sgme/fp';
import { v4 } from 'uuid';

import { cashApi } from '@/store/cash/api/index.ts';
import { selectCashTile } from '@/store/cash/selectors/tile.ts';
import type { AppState } from '@/store/store.ts';

import { cashReset } from '../slice';

export const resetCash = createAsyncThunk('cash/reset', (tileId: string, thunkAPI) => {
  const currentState = thunkAPI.getState() as AppState;

  thunkAPI.dispatch(
    cashReset({
      tileId,
      userPreferences: currentState.userPreferences,
      sessionId: v4(),
    }),
  );

  const updatedState = thunkAPI.getState() as AppState;

  const resetTile = selectCashTile(updatedState, tileId);

  if (isNotDefined(resetTile) || isNotDefined(resetTile.type) || isNotDefined(resetTile.tradeCapture)) {
    return;
  }

  thunkAPI.dispatch(
    // @ts-expect-error ok, it is because there is a union type
    cashApi.endpoints.checkCashByTradeCapture.initiate({
      tileId,

      type: 'FxSpot',

      properties: {
        ...resetTile.properties,
      },
    }),
  );
});
